module.exports = __webpack_public_path__ + "img/blogSolidIcon.3210918e.svg";